import ApiClient from "../api/apiClient";

const CPDSUBMISSIONLIST = "/cpds/cpd-submission";
const CPDACTIVITYBYID = "/cpds/";
const CPDSUBMISSIONSTATUSUPDATE = "/cpds/cpd-submission";
const FINDCPD = "/cpds/find-cpd";
const CPDSTATUSCOUNT = "/cpds/get-user-cpd-status-count";
const UPDATECPDACTIVITY = "/user-cpd-activities/";
const UPDATECPDACTIVITYID = "/cpds/";
const UPDATEBULKCPDSTATUS = "/cpds/multiple-cpd-submission";
const GETCPDACTIVITYHOURS = "cpds/get-cpd-hours";

const getCpdSubmissionList = ({
    page,
    limit,
    status,
    search,
    certificate_type,
    registered_from,
    registered_to,
    start_date,
    end_date,
    full_name,
    identity_number,
    technology_field,
    organization,
    type_of_cpd,
    submission_date,
}) => {
    const baseUrl = `${CPDSUBMISSIONLIST}?`;

    let queryParams = "";

    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}&status=${status}`;

    // Add optional parameters if present

    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (search) queryParams += `&search=${search}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (organization) queryParams += `&organization=${organization}`;
    if (type_of_cpd) queryParams += `&type_of_cpd=${type_of_cpd}`;
    if (submission_date) queryParams += `&submission_date=${submission_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getCpdById = ({ id }) => {
    const url = CPDACTIVITYBYID + id;
    return ApiClient.get(url);
};

const updateCpdSubmissionActivityStatus = (data) => {
    return ApiClient.patch(CPDSUBMISSIONSTATUSUPDATE, data);
};

const getCPD = ({ page, search }) => {
    let url;
    if (page && search) {
        url = ApiClient.get(`${FINDCPD}?page=${page}&limit=${10}&search=${search}`);
    } else {
        url = ApiClient.get(`${FINDCPD}?page=${page}&limit=${10}`);
    }
    return url;
};

const getCPDStatusCount = ({
    status,
    search,
    certificate_type,
    registered_from,
    registered_to,
    start_date,
    end_date,
    full_name,
    identity_number,
    technology_field,
    organization,
    type_of_cpd,
    submission_date,
}) => {
    const baseUrl = `${CPDSTATUSCOUNT}?`;

    let queryParams = "";

    // Add optional parameters if present
    if (status) queryParams += `&status=${status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (search) queryParams += `&search=${search}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (organization) queryParams += `&organization=${organization}`;
    if (type_of_cpd) queryParams += `&type_of_cpd=${type_of_cpd}`;
    if (submission_date) queryParams += `&submission_date=${submission_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const updateCPDActivity = (id, data) => {
    const url = UPDATECPDACTIVITY + id;
    return ApiClient.put(url, data);
};

const updateCpdActivityId = (id, data) => {
    const url = UPDATECPDACTIVITYID + id;
    return ApiClient.put(url, data);
};

const updateBulkCPDStatus = (data) => {
    return ApiClient.patch(UPDATEBULKCPDSTATUS, data);
};

const getCPDActivityHours = (user_id) => {
    const url = `${GETCPDACTIVITYHOURS}?user_id=${user_id}`;
    return ApiClient.get(url);
};

export const cpdSubmissionService = {
    getCpdSubmissionList,
    getCpdById,
    updateCpdSubmissionActivityStatus,
    getCPD,
    getCPDStatusCount,
    updateCPDActivity,
    updateCpdActivityId,
    updateBulkCPDStatus,
    getCPDActivityHours,
};
